import GameState, { getXYindex } from "../state/gameState";
import Phaser from "phaser";
import { EntityKind, ExtendedBlock } from "../state/entityKinds";
import { Dir } from "./Player";
import BaseEntity from "./BaseEntity";
import { RemovedBecause } from "../state/rules/overlap";
import { GAME_VARIABLES, layerDepthDiff } from "../constants";
import { autoTile4bit_filter } from "../art/autotiler";
import { SoundPlayer } from "../sounds/SoundPlayer";

const BOARD_SIZE = 8;

const seededRandom = new Phaser.Math.RandomDataGenerator(
  "randomSeed9182309821309218"
);

export default class ExtendedBlockEntity extends BaseEntity {
  private sprite: Phaser.GameObjects.Sprite;

  constructor(gameState: GameState, scene: Phaser.Scene, obj: ExtendedBlock) {
    super(gameState, scene);

    this.sprite = scene.add.sprite(
      obj.x * BOARD_SIZE,
      obj.y * BOARD_SIZE,
      "atlas",
      "ExtendedBlock/ExtendedBlock_Temp"
    );

    const entity: ExtendedBlock = {
      kind: EntityKind.ExtendedBlock,
      id: this.id,
      x: obj.x,
      y: obj.y,
      sharedBlockId: obj.sharedBlockId,
      entity: () => this,
    };

    gameState.silentMutateGameState((state) => {
      this.idx = getXYindex(obj.x, obj.y);
      state.board[this.idx].push(entity);
    });

    scene.events.on("update", this.update, this);
    scene.events.once("destroy", () => {
      scene.events.removeListener("update", this.update, this);
    });

    this.afterMove();
  }

  update() {
    try {
      this.fixSprite();
    } catch (_) {}
  }

  afterMove() {
    if (this.entityImmutable) {
      this.sprite.setDepth(this.entityImmutable.y + layerDepthDiff.BOXES);
    } else if (this.sprite) {
      this.sprite.setDepth(
        Math.floor(this.sprite.y / 8) - 1 + layerDepthDiff.BOXES
      );
    } else {
      console.log("there is no more entity :<");
    }
  }

  fixSprite() {
    const entity: ExtendedBlock = this.entityImmutable as ExtendedBlock;
    if (entity) {
      const i =
        autoTile4bit_filter(
          EntityKind.ExtendedBlock,
          this.state.gameState.board,
          this.entityImmutable.x,
          this.entityImmutable.y,
          (entities) => {
            return entities.filter(
              (e) =>
                e.kind === EntityKind.ExtendedBlock &&
                e.sharedBlockId === entity.sharedBlockId
            );
          }
        ) + 1;
      this.sprite.setFrame(`ExtendedBlock/ExtendedBlock${i}`);
    }
  }

  _removeFromBoard(reason: RemovedBecause) {
    if (reason === RemovedBecause.ImpactSolid) {
      SoundPlayer.crateBreakSFX(this.scene);
    }
    super._removeFromBoard(reason);
  }

  move(dir: Dir, isDelayed = false) {
    this.moveState(dir);
    SoundPlayer.cratePushSFX(this.scene);
    this._moveTween(dir, {
      targets: this.sprite,
      delay: isDelayed ? GAME_VARIABLES.MOVE_TIME_MS / 2 : 0,
      duration: GAME_VARIABLES.MOVE_TIME_MS / 2,
    });
  }

  undo(c: ExtendedBlock) {
    this.scene.tweens.killTweensOf(this.sprite);
    this.sprite.x = c.x * 8;
    this.sprite.y = c.y * 8;
    this.sprite.alpha = 1;
    this.idx = getXYindex(c.x, c.y);
    this.sprite.setVisible(true);
    this.sprite.setActive(true);
    this.sprite.setDepth(c.y + layerDepthDiff.BOXES);
  }
}
